import { render } from "./WritingCourses.vue?vue&type=template&id=ed48899c"
import script from "./WritingCourses.vue?vue&type=script&lang=js"
export * from "./WritingCourses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__